import { useState, EffectCallback } from 'react'
import { useTranslation } from 'react-i18next'
import {
  FetchUserPlaylistsResponse,
  FetchUserPlaylistsPlaylistTypeEnum,
} from '../swagger'
import { playlistApi } from '../api/swagger'
import { useAppSnackbar } from './useAppSnackbar'
import { useLoadingIds } from './useLoadingIds'
import useLoadingContext from './useLoadingContext'

export interface FetchPlaylistHookProps {
  playlistType: FetchUserPlaylistsPlaylistTypeEnum
}
interface FetchPlaylistHookResponse {
  playlistsContent: FetchUserPlaylistsResponse | undefined
  isLoading: boolean
  triggerFetch: EffectCallback
}

export function useFetchPlaylists({
  playlistType,
}: FetchPlaylistHookProps): FetchPlaylistHookResponse {
  const { t } = useTranslation()
  const {
    Playlist: { fetchUserPlaylists: fetchUserPlaylistsLoadingId },
  } = useLoadingIds()
  const [playlistsContent, setPlaylistContent] =
    useState<FetchUserPlaylistsResponse>()

  const { handleError } = useAppSnackbar()

  const defaultErrorMessage = t(
    'Playlist.Error.FetchUserPlaylists',
    'Error occurred while retrieving playlists'
  )

  const fetchPlaylists = async () => {
    try {
      const fetchedPlayList = await playlistApi.fetchUserPlaylists({
        playlistType: playlistType,
      })
      setPlaylistContent(fetchedPlayList)
    } catch (error) {
      await handleError(error, defaultErrorMessage)
    }
  }
  const { triggerFetch, isLoading } = useLoadingContext({
    asyncFunction: fetchPlaylists,
    loadingId: fetchUserPlaylistsLoadingId,
  })

  return { playlistsContent, isLoading, triggerFetch }
}
